import {
    databaseCreateRow,
    databaseDeleteRow,
    databaseLoadOptions,
    databaseLoadTable,
    databaseUpdateRow,
} from '../../store/actions/database'
import { databaseActions } from '../../store/slices/database'
import { databasePageActions } from '../../store/slices/databasePage'

export const databaseEffectsActions = {
    databaseLoadTable,
    databaseLoadOptions,
    clearErrors: databaseActions.clearErrors,
    setSelectedTable: databasePageActions.setSelectedTable,
    resetFormData: databasePageActions.resetFormData,
    cancelEditingRow: databasePageActions.cancelEditingRow,
}

export const databaseSidebarActions = {
    setSelectedTable: databasePageActions.setSelectedTable,
}

export const databaseAddFormActions = {
    updateFormField: databasePageActions.updateFormField,
    databaseCreateRow,
}

export const databaseTableActions = {
    startEditingRow: databasePageActions.startEditingRow,
    cancelEditingRow: databasePageActions.cancelEditingRow,
    updateEditField: databasePageActions.updateEditField,
    setDeleteModal: databasePageActions.setDeleteModal,
    databaseUpdateRow,
}

export const databaseModalsActions = {
    setDeleteModal: databasePageActions.setDeleteModal,
    databaseDeleteRow,
}
